(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gifty-open-ai]');
    if (!trigger) return;
    const launcher = document.querySelector('.gx91-ai [data-gx91-open]');
    if (!launcher) {
      window.location.href = '/pages/support#ai-support';
      return;
    }
    launcher.click();
  });
})();
